@import '../../sass/base/variables';
@import '../../sass/variables/buttons';
@import '../../sass/base/mixins';
@import '../../sass/mixins/links';
@import '../../sass/mixins/border-radius';
@import '../../sass/mixins/transition';
@import '../../sass/mixins/buttons';

.list-item {
  color: $body-copy;

  &.header {
    display: flex;
    align-items: center;
    height: 100%;

    @include hover-focus{
      background-color: transparent;
    }
    &::slotted(a) {
      @include header-list-link;
    }
  }

  &.sidebar-child {
    &::slotted(a) {
      @include sidebar-child-list-link;
      border: none;
      outline: none;
    }

    @include panel-active-link;
  }

  &.sidebar {
    // @include hover-focus{
    //   background-color: transparent;
    // }
    &::slotted(a) {
      @include sidebar-list-link;
      border: none;
      outline: none;
    }   

    @include panel-active-link;
  }
  &.dropdown{
    &::slotted(a) {
      @include list-link;
    }
  }
  &.dropdown-nav{
    &::slotted(a) {
      @include header-dropdown-link;
    }
  }
  &.panel{
    &::slotted(a) {
      @include panel-list-link;
    }

    @include panel-active-link;
  }
  &.panel-child {
    &::slotted(a) {
      @include panel-child-list-link;
      background: $light-gray;
      border: none;
      outline: none;
    }
    
    @include panel-active-link;
  }
  @include hover-focus{
    background-color: $light-gray;
  }  
}